// eslint-disable-next-line
import * as React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import * as RegistrationReducer from '../../store/RegistrationReducer';
import * as MessageReducer from '../../store/MessageReducer';
import { ApplicationState } from '../../store';
import './RegistrationView.css';
import { getRegistrationRefData, registerNewAccount, searchAddress, getAddressMetadata } from '../../services/RegistrationService';
import { Registration, RegistrationRefData, NewAccountRequest, NewAccountResponse, RegistrationAddress, RegistrationPhoneNumber } from '../../entities/RegistrationEntities';
import regImage from '../../images/registration.jpg';
import successImage from '../../images/registration-success.jpg';
import { Reference } from '../../entities/SystemEntities';
import MessageDialog from '../../components/modal/MessageDialog';
import { aoFormSubmitGtmEvent } from '../../utils/gtm';
import MaintenanceView from '../maintenance/MaintenanceView';
import { PhoneNumberInput } from './PhoneNumberInput';
import Select from '../../components/select/Select';


// ------------------------------------------------------------------------------------------------
// component

const connector = connect(
	(state: ApplicationState) => { return { registrationState: state.registrationState, messageState: state.messageState } },
	{ ...RegistrationReducer.actionCreators, ...MessageReducer.actionCreators }
);

type PropsFromRedux = ConnectedProps<typeof connector>

type Props = PropsFromRedux & {
}

interface State {
	registrationType: string;
	organisationType: string;
	firstName: string;
	lastName: string;
	dateOfBirth: string;
	accountName: string;
	knownAs: string;
	nzbn: string;
	businessAge: string;
	monthlyRevenue: string;
	sthlContact: string;
	lineOfBusiness: string;
	preferredBranch: string;
	productsOfInterest: string[];
	websiteUrl: string;
	phoneNumber: RegistrationPhoneNumber;
	mobileNumber: RegistrationPhoneNumber;
	invoiceEmail: string;
	webshopEmail: string;
	postalAddress: RegistrationAddress;
	deliveryAddress: RegistrationAddress;
	registeredAddress: RegistrationAddress;
	termsConditions: boolean;
	deliveryAddressSelects: Reference[];
	postalAddressSelects: Reference[];
	response: NewAccountResponse;
	highlight: boolean;
	isSubmitted: boolean;
	sameAsPostal: boolean;
	contactPerson: string;
	directors: string;
	consultants: string;
	licenceNumber: string;
	licenceVersion: string;
	agreeCreditNotice: boolean;
	consentContact: boolean;
	accountId: string;
}

const newWindowObject = window as any
let reCaptch = newWindowObject.grecaptcha;

class RegistrationView extends React.Component<Props, State> {

	// --------------------------------------------------------------------------------------------
	// state

	private working: boolean = false;

	state = {
		registrationType: "Existing",
		organisationType: "Company",
		firstName: "",
		lastName: "",
		dateOfBirth: "",
		accountName: "",
		knownAs: "",
		nzbn: "",
		businessAge: "",
		monthlyRevenue: "",
		sthlContact: "",
		lineOfBusiness: "",
		preferredBranch: "",
		productsOfInterest: [],
		websiteUrl: "",
		phoneNumber: new RegistrationPhoneNumber(),
		mobileNumber: new RegistrationPhoneNumber(),
		invoiceEmail: "",
		webshopEmail: "",
		postalAddress: new RegistrationAddress(),
		deliveryAddress: new RegistrationAddress(),
		registeredAddress: new RegistrationAddress(),
		deliveryAddressSelects: [],
		postalAddressSelects: [],
		registeredAddressSelects: [],
		sameAsPostal: false,
		termsConditions: false,
		response: null,
		highlight: false,
		isSubmitted: false,
		contactPerson: "",
		directors: "",
		consultants: "",
		licenceNumber: "",
		licenceVersion: "",
		agreeCreditNotice: false,
		consentContact: false,
		accountId: ""
	};

	onInputChanged = (event) => {
		if (this.state.response && !this.state.response.isError) {
			return;
		}
		let name = event.target.name;
		let value = event.target.type === "checkbox" ? event.target.checked : event.target.value;

		let newState = { ...this.state };
		newState[name] = value;
		this.setState(newState);
	}

	onSelectChanged = (name, value) => {
		let newState = { ...this.state };
		newState[name] = value;
		this.setState(newState);
	}

	onAddressInputChanged = (event, type) => {
		if (this.state.response && !this.state.response.isError) {
			return;
		}
		let name = event.target.name;
		let value = event.target.value;
		let newState = { ...this.state };
		newState[type][name] = value;
		this.setState(newState)
		if (name === "street") {
			this.searchAddress(value, type);
		}
	}

	onPhoneNumberInputChange = (name: string, value: RegistrationPhoneNumber) => {
		let newState = { ...this.state };
		newState[name] = value;
		this.setState(newState);
	}

	onAddressInputBlur = () => {
		setTimeout(() => {
			if (this.state.response && !this.state.response.isError) {
				return;
			}
			let newState = { ...this.state };
			newState.postalAddressSelects = [];
			newState.deliveryAddressSelects = [];
			newState.registeredAddressSelects = [];
			this.setState(newState);
		}, 150)
	}

	onSelectAddress = (pxid: string, type: string) => {
		if (this.state.response && !this.state.response.isError) {
			return;
		}

		getAddressMetadata(pxid)
			.then(response => {
				if (response.errorMessage) {
					alert(response.errorMessage);
				}
				else {
					let newState = { ...this.state };
					newState[type] = response.address;
					this.setState(newState);
				}
			})
			.catch(error => {
				alert(error);
			});
	}

	// --------------------------------------------------------------------------------------------
	// lifecycle

	public componentDidMount() {
		if (!this.props.registrationState.referenceData) {
			this.loadReferenceData();
		}
	}

	public componentDidUpdate(prevProps: Props, prevState: State) {
	}

	// --------------------------------------------------------------------------------------------
	// data

	loadReferenceData = () => {
		if (this.working) {
			return;
		}

		// load
		this.working = true;
		getRegistrationRefData()
			.then(response => {
				this.working = false;

				if (response.errorMessage) {
					alert(response.errorMessage);
				}
				else {
					this.props.setRegistrationRefData(response);
				}
			})
			.catch(error => {
				this.working = false;
				alert(error);
			});
	}

	searchAddress = (query: string, type: string) => {
		// search
		searchAddress(query, type !== "deliveryAddress")
			.then(response => {
				if (response.errorMessage) {
					alert(response.errorMessage);
				}
				else {
					let newState = { ...this.state };

					if (type === "postalAddress") {
						newState.postalAddressSelects = response.addressSearchResults;
					} else if (type === "deliveryAddress") {
						newState.deliveryAddressSelects = response.addressSearchResults;
					} else if (type === "registeredAddress") {
						newState.registeredAddressSelects = response.addressSearchResults;
					}
					this.setState(newState)
				}
			})
			.catch(error => {
				alert(error)
			})
	}

	submitRegistration = () => {

		const self = this;
		if (this.working) {
			return;
		}
		if (this.state.isSubmitted && !this.state.response.isError) {
			this.props.showErrorDialog("Error", "Your registration has already been submitted");
			this.working = false;
			return;
		}

		// registration
		let reg: Registration = new Registration();
		reg.registrationType = this.state.registrationType;
		reg.firstName = this.state.firstName;
		reg.lastName = this.state.lastName;
		reg.accountName = this.state.accountName;
		reg.knownAs = this.state.knownAs;
		reg.websiteUrl = this.state.websiteUrl;
		reg.invoiceEmail = this.state.invoiceEmail;
		reg.webshopEmail = this.state.webshopEmail;
		reg.preferredBranch = this.state.preferredBranch;
		reg.lineOfBusiness = this.state.lineOfBusiness;
		reg.productsOfInterest = this.state.productsOfInterest.join(", ")

		// address
		reg.deliveryAddress = this.state.deliveryAddress;
		reg.postalAddress = this.state.postalAddress;
		if (this.state.sameAsPostal) {
			reg.registeredAddress = this.state.postalAddress;
		} else {
			reg.registeredAddress = this.state.registeredAddress;
		}

		// phone number
		reg.phoneNumber = this.formatPhoneNumber(this.state.phoneNumber);
		reg.mobileNumber = this.formatPhoneNumber(this.state.mobileNumber);

		reg.organisationType = this.state.organisationType;
		reg.accountId = this.state.accountId;
		reg.dateOfBirth = this.state.dateOfBirth;
		reg.nzbn = this.state.nzbn;
		reg.businessAge = this.state.businessAge;
		reg.monthlyRevenue = this.state.monthlyRevenue;
		reg.contactPerson = this.state.contactPerson;
		reg.directors = this.state.directors;
		reg.consultants = this.state.consultants;
		reg.licenceNumber = this.state.licenceNumber;
		reg.licenceVersion = this.state.licenceVersion;
		reg.agreeCreditNotice = this.state.agreeCreditNotice
		reg.sthlContact = this.state.sthlContact;
		reg.sameAsPostal = this.state.sameAsPostal;

		// request
		let request: NewAccountRequest = new NewAccountRequest();
		request.registration = reg;

		self.working = true;

		reCaptch.enterprise.ready(function () {
			reCaptch.enterprise.execute('6LemvTIiAAAAAFHVFwvxgq0j92U6yxlteC4Bfxvq', { action: 'login' }).then(function (token) {
				request.reCaptchaToken = token;

				// gtm
				aoFormSubmitGtmEvent(reg.registrationType);

				// load
				registerNewAccount(request)
					.then(function (response: NewAccountResponse) {
						self.working = false;
						if (response.isError) {
							this.props.showErrorDialog("Error", response.message);
						} else {
							self.setState({
								isSubmitted: true
							})
						}
					})
					.catch(error => {
						self.props.showErrorDialog("Error", "Submission failed due to unexpected error.  Please try again later");
					})
			});
		});
	}

	validateMandatoryFields = () => {
		let valid: boolean = false;
		if (this.state.registrationType === "Cash") {
			valid = !!this.state.firstName && !!this.state.lastName && !!this.state.lineOfBusiness &&
				!!this.state.preferredBranch && !!this.state.accountName && !!this.state.mobileNumber.number &&
				!!this.state.phoneNumber.number &&
				!!this.state.webshopEmail && !!this.state.invoiceEmail && !!this.state.knownAs &&
				!!this.state.deliveryAddress.city && !!this.state.deliveryAddress.postCode && !!this.state.deliveryAddress.street &&
				!!this.state.postalAddress.city && !!this.state.postalAddress.postCode && !!this.state.postalAddress.street;

		} else if (this.state.registrationType === "Trade") {
			valid = !!this.state.firstName && !!this.state.lastName && !!this.state.lineOfBusiness && this.state.productsOfInterest.length !== 0 &&
				!!this.state.preferredBranch && !!this.state.accountName && !!this.state.mobileNumber.number &&
				!!this.state.phoneNumber.number &&
				!!this.state.webshopEmail && !!this.state.invoiceEmail && !!this.state.knownAs &&
				!!this.state.deliveryAddress.city && !!this.state.deliveryAddress.postCode && !!this.state.deliveryAddress.street &&
				!!this.state.postalAddress.city && !!this.state.postalAddress.postCode && !!this.state.postalAddress.street && !!this.state.businessAge && !!this.state.monthlyRevenue;

			if (this.state.organisationType === "Company" || this.state.organisationType === "LtdPartnership") {
				valid = valid && !!this.state.nzbn;
				if (!this.state.sameAsPostal) {
					valid = valid && !!this.state.registeredAddress.city
						&& !!this.state.registeredAddress.postCode && !!this.state.registeredAddress.street;
				}
			}

			if (this.state.organisationType === "RegPartnership" || this.state.organisationType === "SoleTrader") {
				valid = valid && !!this.state.dateOfBirth && !!this.state.licenceNumber && !!this.state.licenceVersion;
			}
		} else if (this.state.registrationType === "Existing") {
			valid = !!this.state.firstName && !!this.state.lastName && !!this.state.accountName && !!this.state.accountId && !!this.state.webshopEmail;
		}


		if (!valid) {
			let newState = { ...this.state }
			newState.highlight = true;
			this.setState(newState);
			this.props.showErrorDialog("Required Fields", "Please enter values into all required fields");
		}
		return valid;
	}

	validateFields = () => {
		const namePattern = /^(?=.{1,50}$)[a-z]+(?:['_.\s][a-z]+)*$/i;
		const emailPattern = /^[\w._%+-]+@[\w.-]+\.[a-zA-Z]{2,7}$/;
		const accountPattern = /^\d{7}$/;

		if (this.state.registrationType === "Existing") {
			if (!accountPattern.test(this.state.accountId)) {
				this.props.showErrorDialog("Prompt", "Please enter a valid account number")
				return false;
			}
			if (!emailPattern.test(this.state.webshopEmail) || this.state.webshopEmail.length <= 5) {
				this.props.showErrorDialog("Prompt", "Please enter a valid email address")
				return false;
			}
			if (!this.state.termsConditions) {
				this.props.showErrorDialog("Prompt", "You must agree with the Terms and Conditions of Trade to submit the account application");
				return false;
			}
		}

		if (this.state.registrationType === "Trade") {
			if (!this.isValidPhoneNumber(this.state.mobileNumber.number)) {
				this.props.showErrorDialog("Prompt", "Please enter a valid mobile phone number");
				return false;
			}
			if (!this.isValidPhoneNumber(this.state.phoneNumber.number)) {
				this.props.showErrorDialog("Prompt", "Please enter a valid business phone number");
				return false;
			}
			if (!emailPattern.test(this.state.webshopEmail) || this.state.webshopEmail.length <= 5) {
				this.props.showErrorDialog("Prompt", "Please enter a valid email address")
				return false;
			}
			if (!emailPattern.test(this.state.invoiceEmail) || this.state.invoiceEmail.length <= 5) {
				this.props.showErrorDialog("Prompt", "Please enter a valid email address")
				return false;
			}
			if (!this.state.agreeCreditNotice) {
				this.props.showErrorDialog("Prompt", "You must agree with the credit application notice");
				return false;
			}
			if (!this.state.termsConditions) {
				this.props.showErrorDialog("Prompt", "You must agree with the Terms and Conditions of Trade to submit the account application");
				return false;
			}
		}

		// reg patterns

		if (this.state.registrationType === "Cash") {
			if (!this.state.termsConditions) {
				this.props.showErrorDialog("Prompt", "You must agree with the Terms and Conditions of Trade to submit the account application");
				return false;
			}
			if (!namePattern.test(this.state.lastName) || !namePattern.test(this.state.firstName)) {
				this.props.showErrorDialog("Prompt", "No special characters and numbers are allowed in First Name and Surname")
				return false;
			}
			if (!this.isValidPhoneNumber(this.state.mobileNumber.number)) {
				this.props.showErrorDialog("Prompt", "Please enter a valid mobile phone number");
				return false;
			}
			if (!this.isValidPhoneNumber(this.state.phoneNumber.number)) {
				this.props.showErrorDialog("Prompt", "Please enter a valid business phone number");
				return false;
			}
			if (!emailPattern.test(this.state.invoiceEmail) || this.state.invoiceEmail.length <= 5) {
				this.props.showErrorDialog("Prompt", "Please enter a valid email address")
				return false;
			}
			if (!emailPattern.test(this.state.webshopEmail) || this.state.webshopEmail.length <= 5) {
				this.props.showErrorDialog("Prompt", "Please enter a valid email address")
				return false;
			}
			if (this.state.accountName.length <= 5) {
				this.props.showErrorDialog("Prompt", "Please enter a valid account name")
				return false;
			}
			if (this.state.knownAs.length <= 5) {
				this.props.showErrorDialog("Prompt", "Please enter a valid trading as name")
				return false;
			}
			if (this.state.deliveryAddress.street.length < 5 || this.state.deliveryAddress.city.length < 3 || this.state.deliveryAddress.postCode.length !== 4) {
				this.props.showErrorDialog("Prompt", "Please enter a valid delivery address")
				return false;
			}
			if (this.state.postalAddress.street.length < 5 || this.state.postalAddress.city.length < 3 || this.state.postalAddress.postCode.length !== 4) {
				this.props.showErrorDialog("Prompt", "Please enter a valid postal address")
				return false;
			}
		}


		// post box
		const disallowPostBoxTypes = ["p.o", "po box", "private bag", "private box"];
		let streetAddressLower = this.state.deliveryAddress.street.toLowerCase();
		for (let i = 0; i < disallowPostBoxTypes.length; i++) {
			if (streetAddressLower.indexOf(disallowPostBoxTypes[i]) !== -1) {
				this.props.showErrorDialog("Prompt", "Invalid delivery address, we do not deliver to PO boxes or Private Bags")
				return false;
			}
		}

		return true;
	}

	formatPhoneNumber = (phoneNumber: RegistrationPhoneNumber) => {
		const { countryCode, number } = phoneNumber;
		if (number === null || number === "") {
			return "";
		}

		const formattedNumber = number.replace(/^0+/, "");

		if (formattedNumber === "") {
			return "";
		}

		const formattedPhoneNumber = countryCode + formattedNumber;
		return formattedPhoneNumber;
	}

	isValidPhoneNumber(phoneNumber: string) {
		const regex = /^(\d)(?!\1{5,})\d{6,}$/;
		const isValid = regex.test(phoneNumber);

		return isValid;
	}

	// --------------------------------------------------------------------------------------------
	// actions

	onClickSubmit = () => {
		if (this.validateMandatoryFields() && this.validateFields()) {
			this.submitRegistration();
		}
	}

	// --------------------------------------------------------------------------------------------
	// render
	private GetMaintenanceFlag(): boolean {
		let refData: RegistrationRefData = this.props.registrationState.referenceData;
		let isMaintenanceMode = refData ? refData.isMaintenanceMode : false;
		return isMaintenanceMode;
	}

	private getLinesOfBusiness(): Reference[] {
		let refData: RegistrationRefData = this.props.registrationState.referenceData;
		let options: Reference[] = refData ? refData.linesOfBusiness : [];
		return options;
	}

	private getBranches(): Reference[] {
		let refData: RegistrationRefData = this.props.registrationState.referenceData;
		let options: Reference[] = refData ? refData.branches : [];
		return options;
	}

	private getProducts(): Reference[] {
		let refData: RegistrationRefData = this.props.registrationState.referenceData;
		let options: Reference[] = refData ? refData.productOfInterests : [];
		return options;
	}

	public render() {
		let isMaintenanceMode = this.GetMaintenanceFlag();
		let messageData = this.props.messageState.data;
		let lobs = this.getLinesOfBusiness();
		let branches = this.getBranches();
		let products = this.getProducts();
		let containerClass = "reg-view-container";
		if (this.state.highlight) {
			containerClass += " highlight";
		}
		let showSubmit: boolean = !this.state.response || this.state.response.isError;

		let trade: boolean = this.state.registrationType === "Trade";
		let cash: boolean = this.state.registrationType === "Cash";
		let existing: boolean = this.state.registrationType === "Existing";

		let company: boolean = this.state.organisationType === "Company";
		let soleTrader: boolean = this.state.organisationType === "SoleTrader";
		let regPartnership: boolean = this.state.organisationType === "RegPartnership";
		let ltdPartnership: boolean = this.state.organisationType === "LtdPartnership";

		let showDob: boolean = trade && (soleTrader || regPartnership);
		let showNzbn: boolean = trade && (company || ltdPartnership);
		let showRegisteredAddress: boolean = trade && (company || ltdPartnership);
		let showDirectors: boolean = trade && !soleTrader;
		let showLicence: boolean = trade && (soleTrader || regPartnership);
		return (
			<>
				{isMaintenanceMode ? (<MaintenanceView />)
					: (
						<div className={containerClass}>
							{this.state.isSubmitted ? (
								<>
									<img src={successImage} alt="Webshop Registration" />
									<div className='reg-view-success-message'>
										<p>Thank you! Watch out for your emails, we'll let you know when you are good to go!</p>
									</div>
								</>
							) : (
								<>
									<div className='reg-view-title'> Open an account with Steel & Tube</div>

									<img src={regImage} alt="Webshop Registration" />
									<div className="reg-view-body">

										{/* registration type */}
										<div className="reg-view-type">
											<div className="reg-view-type-header">
												<span className="required">Please select the account type you wish to apply for</span>
											</div>
											<div className="reg-view-radio">
												<input
													type="radio"
													id="rgtype-existing"
													name="registrationType"
													value="Existing"
													checked={this.state.registrationType === "Existing"}
													onChange={this.onInputChanged}
												/>
												<label htmlFor="rgtype-existing">Webshop account (existing customers with a Steel & Tube account)</label>
											</div>

											<div className="reg-view-radio">
												<input
													type="radio"
													id="rgtype-trade"
													name="registrationType"
													value="Trade"
													checked={this.state.registrationType === "Trade"}
													onChange={this.onInputChanged}
												/>
												<label htmlFor="rgtype-trade">Trade account (requires a credit application)</label>
											</div>

											<div className="reg-view-radio">
												<input
													type="radio"
													id="rgtype-cash"
													name="registrationType"
													value="Cash"
													checked={this.state.registrationType === "Cash"}
													onChange={this.onInputChanged}
												/>
												<label htmlFor="rgtype-cash">Cash account (auto-access to the Webshop)</label>
											</div>
										</div>

										{/* organisation type */}
										{trade ? (
											<div className="reg-view-type">
												<div className="reg-view-type-header">
													<span className="required">Type of organisation</span>
												</div>
												<div className="reg-view-radio">
													<input
														type="radio"
														id="orgtype-company"
														name="organisationType"
														value="Company"
														checked={this.state.organisationType === "Company"}
														onChange={this.onInputChanged}
													/>
													<label htmlFor="orgtype-company">Company</label>
												</div>
												<div className="reg-view-radio">
													<input
														type="radio"
														id="orgtype-ltdpart"
														name="organisationType"
														value="LtdPartnership"
														checked={this.state.organisationType === "LtdPartnership"}
														onChange={this.onInputChanged}
													/>
													<label htmlFor="orgtype-ltdpart">Limited Partnership</label>
												</div>
												<div className="reg-view-radio">
													<input
														type="radio"
														id="orgtype-regpart"
														name="organisationType"
														value="RegPartnership"
														checked={this.state.organisationType === "RegPartnership"}
														onChange={this.onInputChanged}
													/>
													<label htmlFor="orgtype-regpart">Regular Partnership</label>
												</div>
												<div className="reg-view-radio">
													<input
														type="radio"
														id="orgtype-trust"
														name="organisationType"
														value="Trust"
														checked={this.state.organisationType === "Trust"}
														onChange={this.onInputChanged}
													/>
													<label htmlFor="orgtype-trust">Trust</label>
												</div>
												<div className="reg-view-radio">
													<input
														type="radio"
														id="orgtype-soletrader"
														name="organisationType"
														value="SoleTrader"
														checked={this.state.organisationType === "SoleTrader"}
														onChange={this.onInputChanged}
													/>
													<label htmlFor="orgtype-soletrader">Sole Trader</label>
												</div>
												<div className="reg-view-radio">
													<input
														type="radio"
														id="orgtype-other"
														name="organisationType"
														value="Other"
														checked={this.state.organisationType === "Other"}
														onChange={this.onInputChanged}
													/>
													<label htmlFor="orgtype-other">Other</label>
												</div>
											</div>
										) : null}

										{/* first name, last name */}
										<div className="reg-view-row">
											<div className="reg-view-control required">
												<span>First Name</span>
												<input
													type="text"
													placeholder="First Name"
													name="firstName"
													value={this.state.firstName}
													onChange={this.onInputChanged}
													maxLength={50}
												/>
											</div>
											<div className="reg-view-control required">
												<span>Last Name</span>
												<input
													type="text"
													placeholder="Last Name"
													name="lastName"
													value={this.state.lastName}
													onChange={this.onInputChanged}
													maxLength={50}
												/>
											</div>
										</div>

										{/* date of birth */}
										{showDob ? (
											<div className="reg-view-row">
												<div className="reg-view-control required">
													<span>Date of Birth</span>
													<input
														type="text"
														placeholder="DD/MM/YYYY"
														name="dateOfBirth"
														value={this.state.dateOfBirth}
														onChange={this.onInputChanged}
														maxLength={10}
													/>
												</div>
											</div>
										) : null}

										{/* account name */}
										<div className="reg-view-row">
											<div className="reg-view-control required">
												<span>Account Name</span>
												<input
													type="text"
													placeholder="Account Name"
													name="accountName"
													value={this.state.accountName}
													onChange={this.onInputChanged}
													maxLength={100}
												/>
											</div>
										</div>

										{/* account id, order email */}
										{existing ? (
											<>
												<div className="reg-view-row">
													<div className="reg-view-control required">
														<span>Steel & Tube Account ID</span>
														<input
															type="text"
															placeholder="Steel & Tube Account ID"
															name="accountId"
															value={this.state.accountId}
															onChange={this.onInputChanged}
															maxLength={7}
														/>
													</div>
												</div>
												<div className="reg-view-row">
													<div className="reg-view-control required">
														<span>Email to log into the webshop</span>
														<input
															type="text"
															placeholder="Email to log into the webshop"
															name="webshopEmail"
															value={this.state.webshopEmail}
															onChange={this.onInputChanged}
															maxLength={80}
														/>
													</div>
												</div>
											</>
										) : null}


										{cash || trade ? (
											<>
												{/* trading as */}
												<div className="reg-view-row">
													<div className="reg-view-control required">
														<span>Trading as</span>
														<input
															type="text"
															name="knownAs"
															placeholder='Trading as'
															value={this.state.knownAs}
															onChange={this.onInputChanged}
															maxLength={100}
														/>
													</div>
												</div>

												{/* nzbn */}
												{showNzbn ? (
													<div className="reg-view-row">
														<div className="reg-view-control required">
															<span>NZ Business Number (NZBN)</span>
															<input
																type="text"
																placeholder="NZ Business Number (NZBN)"
																name="nzbn"
																value={this.state.nzbn}
																onChange={this.onInputChanged}
																maxLength={20}
															/>
														</div>
													</div>
												) : null}

												{/* business age, monthly revenue */}
												{trade ? (
													<>
														<div className="reg-view-row">
															<div className="reg-view-control required">
																<span>How long in this particular business</span>
																<input
																	type="text"
																	placeholder="How long in this particular business"
																	name="businessAge"
																	value={this.state.businessAge}
																	onChange={this.onInputChanged}
																	maxLength={20}
																/>
															</div>
														</div>
														<div className="reg-view-row">
															<div className="reg-view-control required">
																<span>Expected monthly value of purchases</span>
																<input
																	type="text"
																	placeholder="Expected monthly value of purchases"
																	name="monthlyRevenue"
																	value={this.state.monthlyRevenue}
																	onChange={this.onInputChanged}
																	maxLength={20}
																/>
															</div>
														</div>
													</>
												) : null}

												{/* preferred branch */}
												<div className="reg-view-row">
													<div className="reg-view-control required">
														<span>Preferred Branch</span>
														<Select
															name="preferredBranch"
															placeHolder='Select Prefereed Branch'
															value={this.state.preferredBranch}
															onChange={this.onSelectChanged}
															options={branches}
															highlight={this.state.highlight}
														/>
													</div>
												</div>

												{/* line of business */}
												<div className="reg-view-row">
													<div className="reg-view-control required">
														<span>Line of Business</span>
														<Select
															name="lineOfBusiness"
															placeHolder='Select Line of Business'
															value={this.state.lineOfBusiness}
															onChange={this.onSelectChanged}
															options={lobs}
															highlight={this.state.highlight}
														/>
													</div>
												</div>

												{/* products of interest */}
												{
													trade ? (
														<div className="reg-view-row">
															<div className="reg-view-control required">
																<span>Products of interest</span>
																<Select
																	name="productsOfInterest"
																	placeHolder="Select Products of Interest"
																	options={products}
																	value={this.state.productsOfInterest}
																	onChange={this.onSelectChanged}
																	highlight={this.state.highlight}
																	multiple
																/>
															</div>
														</div>
													) : null
												}

												{/* website */}
												<div className="reg-view-row">
													<div className="reg-view-control">
														<span>Website</span>
														<input
															type="text"
															name="websiteUrl"
															placeholder='Website Url'
															value={this.state.websiteUrl}
															onChange={this.onInputChanged}
															maxLength={200}
														/>
													</div>
												</div>

												{/* S&T contact person */}
												{trade ? (
													<>
														<div className="reg-view-row">
															<div className="reg-view-control">
																<span>Steel & Tube Contact Person (if known)</span>
																<input
																	type="text"
																	placeholder="Full Name"
																	name="sthlContact"
																	value={this.state.sthlContact}
																	onChange={this.onInputChanged}
																	maxLength={20}
																/>
															</div>
														</div>
													</>
												) : null}

												<div className='reg-view-heading'>Billing Details</div>

												{/* invoice email */}
												<div className="reg-view-control required">
													<span>Email for Invoicing</span>
													<input
														type="text"
														placeholder="Email address for invoices and statements"
														name="invoiceEmail"
														value={this.state.invoiceEmail}
														onChange={this.onInputChanged}
														maxLength={100}
													/>
												</div>

												{/* business phone */}
												<div className="reg-view-row">
													<div className="reg-view-control required">
														<span>Business Phone </span>
														<PhoneNumberInput
															name="phoneNumber"
															value={this.state.phoneNumber}
															placeholder="91234567"
															onChange={this.onPhoneNumberInputChange}
														/>
													</div>
												</div>

												{/* mobile phone */}
												<div className="reg-view-row">
													<div className="reg-view-control required">
														<span>Mobile Phone</span>
														<PhoneNumberInput
															name="mobileNumber"
															value={this.state.mobileNumber}
															placeholder="211234567"
															onChange={this.onPhoneNumberInputChange}
														/>
													</div>

												</div>

												<div className='reg-view-heading'>Order Placement Details</div>

												{/* order email */}
												<div className="reg-view-row">
													<div className="reg-view-control required">
														<span>Email for Orders, Marketing and Webshop Access</span>
														<input
															type="text"
															placeholder="Email address (orders, marketing, Webshop access)"
															name="webshopEmail"
															value={this.state.webshopEmail}
															onChange={this.onInputChanged}
															maxLength={80}
														/>
													</div>
												</div>

												{/* delivery address */}
												<div className='reg-view-heading'>Delivery Address</div>
												<div className="reg-view-row required">
													<div className="reg-view-control required">
														<span>Street</span>
														<input
															type="text"
															placeholder="Street address"
															name="street"
															value={this.state.deliveryAddress.street}
															onChange={e => { this.onAddressInputChanged(e, "deliveryAddress") }}
															onBlur={this.onAddressInputBlur}
															className="reg-view-address-search-input"
															maxLength={100}
														/>
														{this.state.deliveryAddressSelects.length > 0 ?
															<div className='reg-view-address-search-list'>
																<ul>
																	{this.state.deliveryAddressSelects.map(address =>
																		<li key={address.label} onClick={() => { this.onSelectAddress(address.id, "deliveryAddress") }}> {address.label} </li>
																	)}

																</ul>
															</div>
															: null
														}
													</div>
												</div>
												<div className='reg-view-row'>
													<div className="reg-view-control">
														<span>Suburb</span>
														<input
															type="text"
															placeholder="Suburb"
															name="suburb"
															value={this.state.deliveryAddress.suburb}
															onChange={e => { this.onAddressInputChanged(e, "deliveryAddress") }}
															maxLength={60}
														/>
													</div>
													<div className="reg-view-control required">
														<span>City</span>
														<input
															type="text"
															placeholder="City"
															name="city"
															value={this.state.deliveryAddress.city}
															onChange={e => { this.onAddressInputChanged(e, "deliveryAddress") }}
															maxLength={60}
														/>
													</div>
													<div className="reg-view-control required">
														<span>Postcode</span>
														<input
															type="text"
															placeholder="Postcode"
															name="postCode"
															value={this.state.deliveryAddress.postCode}
															onChange={e => { this.onAddressInputChanged(e, "deliveryAddress") }}
															maxLength={4}
														/>
													</div>
												</div>

												{/* postal address */}
												<div className='reg-view-heading'>Postal Address</div>
												<div className="reg-view-row">
													<div className="reg-view-control required" >
														<span>Street</span>
														<input
															type="text"
															placeholder="Street address"
															name="street"
															value={this.state.postalAddress.street}
															onChange={e => { this.onAddressInputChanged(e, "postalAddress") }}
															onBlur={this.onAddressInputBlur}
															className="reg-view-address-search-input"
															maxLength={100}
														/>
														{this.state.postalAddressSelects.length > 0 ?
															<div className='reg-view-address-search-list'>
																<ul>
																	{this.state.postalAddressSelects.map(address =>
																		<li key={address.label} onClick={() => { this.onSelectAddress(address.id, "postalAddress") }}> {address.label} </li>
																	)}

																</ul>
															</div>
															: null
														}

													</div>
												</div>
												<div className='reg-view-row'>
													<div className="reg-view-control">
														<span>Suburb</span>
														<input
															type="text"
															placeholder="Suburb"
															name="suburb"
															value={this.state.postalAddress.suburb}
															onChange={e => { this.onAddressInputChanged(e, "postalAddress") }}
															maxLength={60}
														/>
													</div>
													<div className="reg-view-control required">
														<span>City</span>
														<input
															type="text"
															placeholder="City"
															name="city"
															value={this.state.postalAddress.city}
															onChange={e => { this.onAddressInputChanged(e, "postalAddress") }}
															maxLength={60}
														/>
													</div>
													<div className="reg-view-control required">
														<span>Postcode</span>
														<input
															type="text"
															placeholder="Postcode"
															name="postCode"
															value={this.state.postalAddress.postCode}
															onChange={e => { this.onAddressInputChanged(e, "postalAddress") }}
															maxLength={4}
														/>
													</div>
												</div>
											</>
										) : null}

										{trade ? (
											<>
												{/* registered address */}
												{showRegisteredAddress ? (
													<>
														<div className='reg-view-heading'>Registered Office Address</div>

														<div className="reg-view-checkbox">
															<input
																type="checkbox"
																name="sameAsPostal"
																checked={this.state.sameAsPostal}
																onChange={this.onInputChanged}
															/>
															<label htmlFor="sameaspostal">Same as Postal Address</label>
														</div>
														{!this.state.sameAsPostal ? (
															<>
																<div className="reg-view-row">
																	<div className="reg-view-control required" >
																		<span>Street</span>
																		<input
																			type="text"
																			placeholder="Street address"
																			name="street"
																			value={this.state.registeredAddress.street}
																			onChange={e => { this.onAddressInputChanged(e, "registeredAddress") }}
																			onBlur={this.onAddressInputBlur}
																			className="reg-view-address-search-input"
																			maxLength={100}
																		/>
																		{this.state.registeredAddressSelects.length > 0 ?
																			<div className='reg-view-address-search-list'>
																				<ul>
																					{this.state.registeredAddressSelects.map(address =>
																						<li key={address.label} onClick={() => { this.onSelectAddress(address.id, "registeredAddress") }}> {address.label} </li>
																					)}

																				</ul>
																			</div>
																			: null
																		}

																	</div>
																</div>

																<div className='reg-view-row'>
																	<div className="reg-view-control">
																		<span>Suburb</span>
																		<input
																			type="text"
																			placeholder="Suburb"
																			name="suburb"
																			value={this.state.registeredAddress.suburb}
																			onChange={e => { this.onAddressInputChanged(e, "registeredAddress") }}
																			maxLength={60}
																		/>
																	</div>
																	<div className="reg-view-control required">
																		<span>City</span>
																		<input
																			type="text"
																			placeholder="City"
																			name="city"
																			value={this.state.registeredAddress.city}
																			onChange={e => { this.onAddressInputChanged(e, "registeredAddress") }}
																			maxLength={60}
																		/>
																	</div>
																	<div className="reg-view-control required">
																		<span>Postcode</span>
																		<input
																			type="text"
																			placeholder="Postcode"
																			name="postCode"
																			value={this.state.registeredAddress.postCode}
																			onChange={e => { this.onAddressInputChanged(e, "registeredAddress") }}
																			maxLength={4}
																		/>
																	</div>
																</div>
															</>
														) : null}
													</>
												) : null}

												{/* contact person */}
												<div className="reg-view-row contact-row">
													<div className="reg-view-control">
														<span>Please nominate someone to be the contact person for your organisation</span>
														<textarea
															placeholder="Full name, postal address, contact phone and email address"
															name="contactPerson"
															value={this.state.contactPerson}
															onChange={this.onInputChanged}
															rows={5}
														/>
													</div>
												</div>

												{/* directors */}
												{showDirectors ? (
													<div className="reg-view-row">
														<div className="reg-view-control">
															<span>Directors and Management</span>
															<textarea
																placeholder="Full names and addresses of directors and partners"
																name="directors"
																value={this.state.directors}
																onChange={this.onInputChanged}
																rows={5}
															/>
														</div>
													</div>
												) : null}

												{/* consultants */}
												<div className="reg-view-row">
													<div className="reg-view-control">
														<span>Professional Consultants</span>
														<textarea
															placeholder="Bank, branch, auditors/accountants, solicitors and any other information we ought to know about which could affect our decision to grant your credit"
															name="consultants"
															value={this.state.consultants}
															onChange={this.onInputChanged}
															rows={5}
														/>
													</div>
												</div>

												{/* licence number and version */}
												{showLicence ? (
													<>
														<div className='reg-view-heading'>Driver Licence</div>

														<div className="reg-view-row">
															<div className="reg-view-control required">
																<span>Licence Number</span>
																<input
																	type="text"
																	placeholder="Driver Licence Number"
																	name="licenceNumber"
																	value={this.state.licenceNumber}
																	onChange={this.onInputChanged}
																	maxLength={20}
																/>
															</div>
															<div className="reg-view-control required">
																<span>Licence Version</span>
																<input
																	type="text"
																	placeholder="Driver Licence Version"
																	name="licenceVersion"
																	value={this.state.licenceVersion}
																	onChange={this.onInputChanged}
																	maxLength={20}
																/>
															</div>
														</div>


													</>
												) : null}
											</>
										) : null}

										<div className="reg-view-footer">
											{trade ? (
												<>
													{/* credit notice */}
													<div className="reg-view-credit-notice">
														<span>I/We confirm that the above information is accurate and complete in all material respects and that it may be held
															and used by Steel & Tube Holdings Limited and its subsidiaries (the Group) to enable members of the Group to:
															consider this application; administer my/our account (if the application is approved);
															monitor my/our creditworthiness on an ongoing basis; recover any monies due to members of the Group by me/us or to
															assist members of the Group in the exercise of any of their rights, powers and remedies.
															I/We acknowledge that the Terms provide for a security interest in favour of the relevant Group member in all my/our
															present personal property and after-acquired property except for any item of personal property which is not
															(or which is exclusively the proceeds of any item of personal property which is not) supplied by that member of the Group
															to me/us to secure the payment by me/us to that member of the Group of all amounts I/We may owe that member of the Group
															from time to time and at any time, including future advances. I/We agree to make all payments due to members of the Group
															by the due date, and if payment is not made by the due date, that (without limiting a members of the Group’s other rights,
															powers and remedies) I/We agree to pay interest specified in the Terms. I/We authorise any person to provide members of
															the Group with such information as members of the Group may require in response to their credit and/or employment enquiries
															and this authorisation may be produced for the purposes of making such enquiries. I/We agree to continue to make at all times full
															and accurate disclosure to members of the Group of any information that may materially affect a Group member’s decision to
															continue granting a credit facility.
														</span>
													</div>

													{/* agree credit notice */}
													<div className="reg-view-checkbox">
														<input
															type="checkbox"
															id="agreeCreditNotice"
															name="agreeCreditNotice"
															checked={this.state.agreeCreditNotice}
															onChange={this.onInputChanged}
														/>
														<label>I agree to the above credit application notice</label>
													</div>

													{/* we will contact you */}
													<div className="reg-view-checkbox">
														<input
															type="checkbox"
															id="consentContact"
															name="consentContact"
															checked={this.state.consentContact}
															onChange={this.onInputChanged}
														/>
														<label>We will contact you if your application requires a guarantor</label>
													</div>
												</>
											) : null}

											{/* agree T&Cs */}
											<div className="reg-view-checkbox">
												<input
													type="checkbox"
													id="termsConditions"
													name="termsConditions"
													checked={this.state.termsConditions}
													onChange={this.onInputChanged}
												/>
												<label> I agree that the terms and conditions of trade will apply to all transactions between me and Steel & Tube
													and have read and understood the  <a href="https://steelandtube.co.nz/corporate/terms-and-conditions">Steel & Tube Terms of Trade</a></label>
											</div>
										</div>

										{/* submit button */}
										<div className="reg-view-row">
											{showSubmit ? (
												<button className='reg-view-button' onClick={this.onClickSubmit}>SUBMIT</button>
											) : null}
										</div>

									</div>
								</>
							)}

							{messageData ? (
								<MessageDialog />
							) : null}
						</div >)
				}
			</>
		);
	}

};

export default connector(RegistrationView);



